import util from "../util.js";

const categoryData = [
  {
    slug: "outdoor-sports-2019",
    title: "アウトドア・スポーツ",
    image: util.makeS3URL("/data/img/KX12401-1.jpg")
  },
  {
    slug: "beauty-health-2019",
    title: "美容・健康",
    image: util.makeS3URL("/data/img/KX19403-1.jpg")
  },
  {
    slug: "kitchen-2019",
    title: "キッチン",
    image: util.makeS3URL("/data/img/KX01201-1.jpg")
  },
  {
    slug: "tableware-2019",
    title: "テーブルウェア",
    image: util.makeS3URL("/data/img/KX07901-1.jpg")
  },
  {
    slug: "daily-necessities-2019",
    title: "デイリー（日用品）",
    image: util.makeS3URL("/data/img/KX18601-1.jpg")
  },
  {
    slug: "interior-2019",
    title: "インテリア・家電",
    image: util.makeS3URL("/data/img/KX09202-1.jpg")
  },
  {
    slug: "gardening-diy-2019",
    title: "ガーデニング・DIY",
    image: util.makeS3URL("/data/img/KX13605-1.jpg")
  },
  {
    slug: "fashion-2019",
    title: "ファッション",
    image: util.makeS3URL("/data/img/KX14205-1.jpg")
  },
  {
    slug: "stationary-2019",
    title: "ステーショナリー",
    image: util.makeS3URL("/data/img/KX11403-1.jpg")
  },
  {
    slug: "food-2019",
    title: "グルメ",
    image: util.makeS3URL("/data/img/KX21501-1.jpg")
  },
  {
    slug: "kids-hobby-pet-2019",
    title: "キッズ・ホビー・ペット",
    image: util.makeS3URL("/data/img/KX10801-1.jpg")
  },
  {
    slug: "general",
    title: "【受付終了】総合カタログ 2016年度",
    image: util.makeS3URL("/data/img-general/21633405-1.jpg"),
    endOfReception: true
  },
  {
    slug: "general-2018",
    title: "【受付終了】総合カタログ 2018年度",
    image: util.makeS3URL("/data/img-general/21633405-1.jpg"),
    endOfReception: true,
    userTitle: "ギフト"
  },
  {
    slug: "general-2019",
    title: "総合カタログ 2019年度",
    image: util.makeS3URL("/data/img-general/21633405-1.jpg"),
    endOfReception: true, // 総合もカテゴリ分類したため不要
    userTitle: "ギフト"
  }
];

export default categoryData;



// WEBPACK FOOTER //
// ./src/reducers/categoryData.js